import { useMemo } from 'react'
export function useDeviceTier() {
  return useMemo(() => {
    const mobile = matchMedia('(max-width: 760px)').matches
    const cores = navigator.hardwareConcurrency || 4
    return { mobile, lowPower: mobile || cores <= 4, dpr: mobile ? [1, 1.35] : [1, 1.75] }
  }, [])
}
